import React, { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { applyClientIdentity, fetchClientLogoUrl } from 'utils/homeScreen';

/*
 * Wraps every /:domain (client) page. Once the client is known it sets the page title, touch icon
 * and web app manifest so "Add to Home Screen" installs this client's SaySomething app.
 * Failures are ignored on purpose: the page keeps its default identity and keeps working.
 */
function DomainLayout() {
  const { domain } = useParams();

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      let logoUrl = null;
      try {
        logoUrl = await fetchClientLogoUrl(domain);
      } catch (e) {
        // unknown client or API error: fall back to the default icon
      }
      if (cancelled) return;
      try {
        await applyClientIdentity({ orgKey: domain, logoUrl });
      } catch (e) {
        // keep the default identity
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [domain]);

  return <Outlet />;
}

export default DomainLayout;
